export { ActionKind as AutocompleteActionKind } from 'prosemirror-autocomplete';
